









import { Component, Vue } from 'vue-property-decorator';
import Modal from '@/plugins/modal/Modal.vue';

interface Layout {
  component: unknown;
  props?: unknown;
}

@Component({
  components: {
    Modal,
  }
})
export default class App extends Vue {
  /**
   * Computed layout component.
   * Take the layout in that last meta defined in routes.
   */
  get layout(): Layout {
    let layout: unknown = undefined;
    this.$route.matched.forEach((route) => {
      if (route.meta.layout) {
        layout = route.meta.layout;
      }
    });
    if (layout instanceof Array && layout.length > 1) {
      // The component is passed with properties.
      return { component: layout[0], props: layout[1] };
    }
    return { component: layout || 'div' };
  }

  mounted() {
    this.tryRecoverSession();
  }

  private tryRecoverSession() {
    this.$axios.get(process.env.VUE_APP_SESSION_API)
      .then((response) => {
        // An active session found, log the user.
        this.$store.commit('login', response.data);
      }).catch(() => { /* No valid session */ });
  }
}
